export default "__VITE_ASSET__Mwo_GwWh1QhSu8GaPk3Sig__"